module.exports = __webpack_public_path__ + "assets/img/table.1ecb185c.png";